// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"He","itemsContainer":"Ie"};